export function decodeToken(token) {
  if (!token) {
    return null;
  }

  try {
    const [, payload] = token.split('.');
    const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
    const decoded = window.atob(normalized);
    const parsed = JSON.parse(decoded);

    return {
      userId: parsed.userId ?? parsed.id ?? (parsed.sub ? Number(parsed.sub) : null),
      username: parsed.username ?? '',
      role: parsed.role ?? null,
      expiresAt: parsed.exp ?? null,
    };
  } catch (error) {
    return null;
  }
}

export function isTokenExpired(decodedToken) {
  if (!decodedToken?.expiresAt) {
    return false;
  }

  return decodedToken.expiresAt * 1000 <= Date.now();
}